import { render } from "./ProjectSwitchButton.vue?vue&type=template&id=96187f3c"
import script from "./ProjectSwitchButton.vue?vue&type=script&lang=js"
export * from "./ProjectSwitchButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\toru-ota\\source\\repos\\Marron\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__